// Analítica ligera para el reporte mensual de desempeño.
// No hace nada si no hay REACT_APP_GA_MEASUREMENT_ID configurado (placeholder vacío por
// defecto) — así el sitio funciona igual mientras el dueño no tenga cuenta de GA4 creada.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

export const isAnalyticsEnabled = () => !!GA_ID;

export function initAnalytics() {
  if (!GA_ID || initialized) return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  // send_page_view en false: las vistas de página se mandan a mano en cada cambio de
  // ruta (trackPageView), porque esto es una SPA y GA4 no detecta las rutas solo.
  gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView(path, title) {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

// Ayudante específico para "cuánta gente hizo clic en WhatsApp" — el dato central
// del reporte mensual. `source` identifica desde dónde se dio el clic (header, hero,
// modal de producto, etc.) para poder ver qué CTA convierte más.
export function trackWhatsAppClick(source, extra = {}) {
  trackEvent('whatsapp_click', { source, ...extra });
}

export function trackProductView(product) {
  if (!product) return;
  trackEvent('view_item', {
    item_id: product.id,
    item_name: product.name,
    item_category: product.category,
  });
}
